import { render, staticRenderFns } from "./NuevoRegimenJubilatorio.vue?vue&type=template&id=664ecd98&"
import script from "./NuevoRegimenJubilatorio.vue?vue&type=script&lang=js&"
export * from "./NuevoRegimenJubilatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports